import { render, staticRenderFns } from "./navigation-main-button.vue?vue&type=template&id=c4ce8832&scoped=true"
import script from "./navigation-main-button.vue?vue&type=script&lang=ts"
export * from "./navigation-main-button.vue?vue&type=script&lang=ts"
import style0 from "./navigation-main-button.vue?vue&type=style&index=0&id=c4ce8832&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ce8832",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4ce8832')) {
      api.createRecord('c4ce8832', component.options)
    } else {
      api.reload('c4ce8832', component.options)
    }
    module.hot.accept("./navigation-main-button.vue?vue&type=template&id=c4ce8832&scoped=true", function () {
      api.rerender('c4ce8832', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/layout/navigation-main-button.vue"
export default component.exports